import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import _ from 'underscore'
import moment from 'moment';
import xtend from 'xtend';
import Switch from 'react-bootstrap-switch';
import DatePicker from 'react-datepicker';
import ReactQuill from 'react-quill';

import ClockPicker from '../../../../common/components/inputs/ClockPicker';
import CategorySelect from '../../../../embed/hoc/types/CategorySelect';

const cleanString = input => input.split('').map(char => char.charCodeAt(0) <= 127 ? char : '').join('')

function getInitialComponentState (props) {
    return {
        validators: [],
        edited: false,
        edits: {
            description: props.event.get('description')
        },
    };
}

const RTEModules = {
    toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link'],
        ['clean']
    ]
}

const RTEFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link'
]

var General = createReactClass({
    propTypes: {
        event: pt.object.isRequired,
        actions: pt.shape({
            edit: pt.func.isRequired
        }).isRequired
    },

    getInitialState: function () {
        return getInitialComponentState(this.props);
    },

    shouldComponentUpdate: function (nextProps, nextState) {
        return this.props !== nextProps || this.state !== nextState;
    },

    handleChange: function (ev) {   

        let value;
        let { name, type } = ev.target;

        switch (type) {
            case 'checkbox':
                value = ev.target.checked;
                break;

            default:
                value = ev.target.value;
        }

        let updates = {};

        switch (name) {
            case 'streamtext':
                updates.liveCaptions = {
                    vendorID: 1,
                    captionID: value
                };
                // liveCaptions is the key that saves the string to the event
                // streamtext is the key used on the control, both need to be updated
                this.props.handleChange('liveCaptions', updates.liveCaptions)
                break;

            case 'startTime':
                updates[name] = value.format('HH:mm:ss');
                break;

            case 'title':
                //no just a space at the start of a string
                if (value === ' ') value = '';
                //use only valid unicode chars
                updates[name] = cleanString(value);
                break;
            default:
                updates[name] = value;
        }

        this.props.handleChange(name, value);
    },

    handlePrivateChange: function (el, value) {
        this.handleChange({
            target: {
                name: 'private',
                type: 'checkbox',
                checked: value
            }
        });
    },

    handleDateChange: function (value) {
        if (value !== null) {
            this.handleChange({
                target: {
                    name: 'startDate',
                    type: 'text',
                    value: value
                }
            });
        }
    },

    handleDescriptionChange: function (value) {
        if (value === "<p><br></p>") {
            this.props.handleChange('description', null);
            return;
        }

        this.props.handleChange('description', value);
        // if (!this.state.edited) {
        //     // https://github.com/quilljs/quill/issues/1134#issuecomment-265065953
        //     var self = this;
        //     _.defer(function () {
        //         self.handleChange({
        //             target: {
        //                 name: 'description',
        //                 type: 'text',
        //                 value: value
        //             }
        //         });
        //     });
        // } else {
            // this.handleChange({
            //     target: {
            //         name: 'description',
            //         type: 'text',
            //         value: value
            //     }
            // });
        // }
    },

    handleTimeChange: function (value) {
        this.handleChange({target: {
            name: 'startTime',
            value: value
        }});
    },

    render: function () {

        let event = xtend(
            this.props.event.toJS(),
            this.props.edits
        )

        let date = event.startDate;
        let time = event.startTime;
        let estimatedRuntime = event.estRuntime;

        var clientTZ = moment.tz(this.props.timeZone)
        var clientTZabbr = clientTZ.format("z");
        var offset = clientTZ.utcOffset() / 60;

        let invalidInputs = []
        if (this.props.hasError !== false) {
            this.props.hasError.map(v => invalidInputs.push(v.key))
        }

        if (this.props.isInGroup && !this.props.edits.categories.length) {
            invalidInputs.push('categories')
        }

        return (
            <div className="tab-general">
                <div className="callout clearfix">
                    <div className="col-sm-10">
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('title') !== -1) ? 'invalid' : 'valid')}>
                            <label>Event Title</label>
                            <input
                                data-testid="create-event-wizard-title"
                                type="text"
                                className="form-control"
                                name="title"
                                placeholder="Required"
                                value={event.title || ''}
                                onChange={this.handleChange}/>
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <label>Private</label>
                        <div style={{display: 'block'}}>
                            <Switch
                                onChange={this.handlePrivateChange}
                                value={event.private}
                                animate={false} />
                        </div>
                    </div>

                    <div className="col-sm-4">
                        <label>Start Date</label>
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('startDate') !== -1) ? 'invalid' : 'valid')}>
                            <div className="input-group" style={{zIndex:4}}>
                                <span className="input-group-addon"><i className="fa fa-calendar"/></span>
                                <DatePicker
                                    className="form-control"
                                    dateFormat="MM/DD/YYYY"
                                    selected={date}
                                    onChange={this.handleDateChange}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-4">
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('startTime') !== -1) ? 'invalid' : 'valid')}>
                            <label>Start Time </label>
                            <span className='tz-notate'>{' ('+clientTZabbr+', UTC '+offset+')'} </span>

                            <div className="input-group">
                                <span className="input-group-addon"><i className="far fa-clock"/></span>
                                <ClockPicker
                                    name="startTime"
                                    value={time}
                                    id={this.props.event.get('eventID') + '-startTime-input'}
                                    handleChange={this.handleTimeChange}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-4">
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('streamtext') !== -1) ? 'invalid' : 'valid')}>
                            <label>StreamText Captioning</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="far fa-closed-captioning"/></span>
                                <input
                                    className="form-control"
                                    name="streamtext"
                                    placeholder="Your StreamText ID"
                                    value={(
                                        event.liveCaptions &&
                                        event.liveCaptions.captionID
                                    ) ? event.liveCaptions.captionID : ""
                                    }
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        this.props.eventType === "live" ? 
                    <div className="col-sm-4">
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('estRuntime') !== -1) ? 'invalid' : 'valid')}>
                            <label>Estimated Runtime</label>

                            <div className="input-group">
                                <span className="input-group-addon"><i className="far fa-clock"/></span>
                               
                                <input 
                                type="text" 
                                placeholder="hh:mm" 
                                className="form-control"
                                maxLength={5} 
                                name="estRuntime"
                                id={this.props.event.get('estRuntime') + '-estRuntime-input'}
                                onChange={(e) => {
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                    const value = e.target.value;
                                    const numOnlyRegex = /[^0-9]/g;

                                    let customValue = value;
                                    
                                    validationWrapperClassList.remove("valid")
                                    validationWrapperClassList.add("invalid")

                                    // don't allow colons except in the 2nd index
                                    if (value.includes(":")) {
                                        if(value.lastIndexOf(":") != 2) {
                                            return
                                        }
                                    }
                                    
                                    // adding the colon at index 2
                                    if (value.length == 2) {
                                        customValue += ":";
                                    }

                                    let inputArray = customValue.split(':');

                                    if (Number(inputArray[0]) > 24) {
                                      inputArray[0] = "24";
                                    } else if (inputArray[0] && inputArray[0].match(numOnlyRegex)) return;

                                    if (Number(inputArray[1]) > 59) {
                                      inputArray[1] = "59";
                                    } else if (inputArray[1] && inputArray[1].match(numOnlyRegex)) return;

                                    if (Number(inputArray[0]) == 24 && inputArray[1]) {
                                        inputArray[1] = "00";   
                                    }

                                    if (inputArray[0] === "00" && inputArray[1] === "00") {
                                        inputArray[0] = "01";
                                        inputArray[1] = "00";
                                    }

                                    const HAMString = inputArray.join(':');

                                    this.props.handleChange("estRuntime", HAMString);
                                    
                                    if (HAMString.length == 5) {
                                        validationWrapperClassList.remove("invalid")
                                        validationWrapperClassList.add("valid")
                                    }                                    

                                    if(!this.state.edited){
                                        this.setState({
                                            ...this.state,
                                            edited: true,
                                        });
                                    }
                                  }} 

                                onKeyDown={(e) => {
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                    if(e.target.value.length == 1) {
                                        validationWrapperClassList.remove("invalid")
                                        validationWrapperClassList.add("valid")
                                    }
                                    if (e.key == 'Backspace') {
                                        this.props.handleChange("estRuntime", e.target.value.slice(0, -1));
                                    }
                                }}

                                onBlur={(e) => {
                                    if (e.target.value.length === 5) return;

                                    let editedValue = e.target.value;
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                    

                                    switch (editedValue.length) {
                                        case 0:
                                            editedValue = "01:00"
                                            break;
                                        case 1:
                                            editedValue = "0" + editedValue + ":00"
                                            break;
                                        case 3:
                                            editedValue += "00"
                                            break;
                                        case 4:
                                            editedValue += "0"
                                            break;
                                        default:
                                            break;
                                    }

                                    if(editedValue === "00:00") {
                                        editedValue = "01:00"
                                    }

                                    validationWrapperClassList.remove("invalid")
                                    validationWrapperClassList.add("valid")

                                    this.props.handleChange("estRuntime", editedValue);
                                }}

                                value={this.state.edited ? estimatedRuntime : "01:00"} />
                            </div>
                        </div>
                    </div> : null

                    }
                    <div className='textarea-container'>
                        <div data-testid="create-event-wizard-description-wrapper">
                            <label>Description</label>

                            <ReactQuill
                                modules={RTEModules}
                                formats={RTEFormats}
                                value={event.description}
                                onChange={this.handleDescriptionChange}>
                            </ReactQuill>
                        </div>
                    
                        <div>
                            <label>Notes</label>
                            <textarea
                                className="form-control"
                                name="notes"
                                value={event.notes ? event.notes : ""}
                                onChange={this.handleChange}/>
                        </div>
                    </div>

                    <div className="col-sm-12">
                        <div className={'validation-wrapper ' + ((invalidInputs.indexOf('categories') !== -1) ? 'invalid' : 'valid')}>
                            <label>Categories</label>
                            {this.props.categories ? <span 
      data-testid="category-select"><CategorySelect
                                categories={this.props.categories}
                                value={[...this.props.edits.categories]}
                                dontAutoAdd={true}
                                storeEdits={val => {
                                    this.props.handleChange('categories', val)
                                }}
                            /></span> : <div>No categories have been created yet</div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default General